import React, { createContext } from "react"

export const siteMetaCtx = createContext({})
